if (!customElements.get('size-selector')) {
  customElements.define(
    'size-selector',
    class SizeSelector extends HTMLElement {
      constructor() {
        super();
        this.onKeydown = this.onKeydown.bind(this);
      }

      connectedCallback() {
        this.select = this.querySelector('.size-selector__native');
        this.trigger = this.querySelector('.size-selector__trigger');
        this.layer = this.querySelector('.size-selector__layer');
        this.panel = this.querySelector('.size-selector__panel');
        this.label = this.querySelector('[data-size-selector-label]');
        this.closeButton = this.querySelector('.size-selector__close');
        this.overlay = this.querySelector('.size-selector__overlay');
        this.options = Array.from(this.querySelectorAll('[data-size-selector-value]'));

        if (!this.select || !this.trigger || !this.layer) return;

        this.trigger.addEventListener('click', () => this.open());
        this.closeButton?.addEventListener('click', () => this.close());
        this.overlay?.addEventListener('click', () => this.close());
        this.options.forEach((option) => {
          option.addEventListener('click', () => this.selectValue(option));
        });
      }

      disconnectedCallback() {
        document.removeEventListener('keydown', this.onKeydown);
        document.documentElement.classList.remove('size-selector-open');
        if (this.layer && this.layer.parentElement === document.body) {
          this.layer.remove();
        }
      }

      get isMobile() {
        return window.matchMedia('(max-width: 749px)').matches;
      }

      open() {
        if (this.isMobile && this.layer.parentElement !== document.body) {
          document.body.appendChild(this.layer);
          document.documentElement.classList.add('size-selector-open');
        }

        this.layer.hidden = false;
        this.trigger.setAttribute('aria-expanded', 'true');
        document.addEventListener('keydown', this.onKeydown);
        requestAnimationFrame(() => {
          this.layer.classList.add('is-open');
          const selected = this.layer.querySelector('.size-selector__option.is-selected:not(:disabled)');
          (selected || this.layer.querySelector('.size-selector__option:not(:disabled)') || this.closeButton)?.focus();
        });
      }

      close({ restoreFocus = true } = {}) {
        if (!this.layer) return;

        this.layer.classList.remove('is-open');
        this.trigger.setAttribute('aria-expanded', 'false');
        document.removeEventListener('keydown', this.onKeydown);
        document.documentElement.classList.remove('size-selector-open');

        const finishClose = () => {
          if (!this.layer || this.layer.classList.contains('is-open')) return;
          this.layer.hidden = true;
          if (this.isConnected && this.layer.parentElement === document.body) {
            this.appendChild(this.layer);
          }
        };

        window.setTimeout(finishClose, this.isMobile ? 350 : 180);
        if (restoreFocus) this.trigger.focus({ preventScroll: true });
      }

      selectValue(optionButton) {
        if (optionButton.disabled) return;

        const value = optionButton.dataset.sizeSelectorValue;
        const matchingOption = Array.from(this.select.options).find((option) => option.value === value);
        if (!matchingOption) return;

        this.options.forEach((option) => {
          const isSelected = option === optionButton;
          option.classList.toggle('is-selected', isSelected);
          option.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        });

        this.label.textContent = optionButton.querySelector('span')?.textContent?.trim() || value;
        this.select.value = value;
        this.close({ restoreFocus: false });
        this.select.dispatchEvent(new Event('change', { bubbles: true }));
      }

      onKeydown(event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          this.close();
        }
      }
    }
  );
}
